import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drilling-table',
  templateUrl: './drilling-table.component.html',
  styleUrls: ['./drilling-table.component.css']
})
export class DrillingTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
